import { Metrika } from '../components/metrika';

function getCookie(name) {
  const fullCookieString = '; ' + document.cookie;
  const splitCookie = fullCookieString.split('; ' + name + '=');
  return splitCookie.length === 2 ? splitCookie.pop().split(';').shift() : null;
}

export function counters() {

    if (getCookie('direct_enter') != '1') {
        const metrika = new Metrika;

        // Yandex.Metrika counter
       (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
       m[i].l=1*new Date();k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.defer=1,k.src=r,a.parentNode.insertBefore(k,a)})
       (window, document, "script", "/app/src/js/vendors/yandex_metrika.js", "ym");

        metrika.init();

        // Global site tag (gtag.js) - Google Analytics
        const script = document.createElement('script');
        script.setAttribute('defer', '');
        script.setAttribute('src', '/app/src/js/vendors/google_analytics.js');
        document.body.append(script);

        const scriptGtag = document.createElement('script');
        scriptGtag.textContent = (`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'UA-148189100-1');
        `);
        document.body.append(scriptGtag);
    }
}
